import dynamic from "next/dynamic";
import { useContext } from "react";
import { Store } from "@store";
import styles from "@styles/profile/profile.module.css";
const ProfileCompletionProgess = dynamic(() => import("@components/profile/CompletionDailog"), {
  ssr: false
});
const JoinedCommunitiesTab = dynamic(() => import("@components/profile/JoinedCommunitiesTab"), {
  ssr: false
});
export default function UserProfileSidebar({
  uid,
  data,
  openEditProfile
}) {
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  return <div id={styles.profile_display_inner_right} className={styles.profile_display_inner_right} data-sentry-component="UserProfileSidebar" data-sentry-source-file="UserProfileSidebar.jsx">
      <div className={styles.profile_display_bottom}>
        {loggedInUser.uid === data.uid && <ProfileCompletionProgess data={data} type="user" onClickHandler={openEditProfile} />}
      </div>
      <JoinedCommunitiesTab uid={uid} data-sentry-element="JoinedCommunitiesTab" data-sentry-source-file="UserProfileSidebar.jsx" />
    </div>;
}